import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { fieldInputPropTypes } from "redux-form/lib/propTypes";

/**
 * ReCaptcha
 */
class ReCaptcha extends Component {
  static propTypes = {
    ...fieldInputPropTypes
  };

  static defaultProps = {};

  render() {
    return (
      <div>
        <ReCAPTCHA sitekey="6LcDegwTAAAAAPyE4eq7qXEoxjsD5h-3n4kGpFHy" onChange={this.props.input.onChange} />
      </div>
    );
  }
}

export default ReCaptcha;
